import React, { Component } from 'react';
import Message from './ValidationMessage';
import InlineField from './InlineField';

export class TextAreaField extends Component {

  render() {
    let { intl, translation, input, required, label, disabled, placeholder,rows, id, displayType, meta: { touched, error, warning } } = this.props;

    if (intl && translation) {
      const labelObj = translation.label;
      const placeholderObj = translation.placeholder;
      if(labelObj && labelObj.message) {
        label = intl.formatMessage(labelObj.message, labelObj.params);
      }
      if(placeholderObj && placeholderObj.message) {
        placeholder = intl.formatMessage(placeholderObj.message, placeholderObj.params);
      }
    }

    let showError = touched && error ? "error" : "";
    let disabledLabel = disabled ? "disabled" : "";
    let requiredLabel = required ? "required" : "";
    let readOnly;

    if ( displayType === 'inline' ) {
      return <InlineField fieldType='renderTextArea' content={input.value} label={label} id={id} />;
    }

    if ( displayType === 'readonly' ) {
      readOnly = true;
    }

    return (
      <div className={`${requiredLabel} ${disabledLabel} field ${showError}`}>
        {label && (<label>{label}</label>)}
        <div>
          <textarea {...input} rows={rows} id={id} readOnly={readOnly} placeholder={placeholder} disabled={ disabled }/>
          <Message show={touched} message={error} />
          <Message show={touched} message={warning} />
        </div>
      </div>
    );
  }

}
